import CallHistoryPage from './CallHistoryPage';

export default CallHistoryPage;

